import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "signOut" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M9.03091 20H5.74982C3.67961 20 2 18.3203 2 16.25V8.75C2 6.67969 3.67961 5 5.74982 5H9.03091C9.28871 5 9.49963 5.21094 9.49963 5.46875V7.03125C9.49963 7.28906 9.28871 7.5 9.03091 7.5H5.74982C5.05844 7.5 4.49988 8.05859 4.49988 8.75V16.25C4.49988 16.9414 5.05844 17.5 5.74982 17.5H9.03091C9.28871 17.5 9.49963 17.7109 9.49963 17.9688V19.5312C9.49963 19.7891 9.28871 20 9.03091 20ZM13.6362 8.16016L16.6673 10.9375H9.18715C8.66764 10.9375 8.24969 11.3555 8.24969 11.875V13.125C8.24969 13.6445 8.66764 14.0625 9.18715 14.0625H16.6673L13.6362 16.8398C13.2416 17.1992 13.2299 17.8164 13.6049 18.1953L14.4603 19.0508C14.8236 19.4141 15.4173 19.418 15.7845 19.0547L21.7217 13.1641C22.0928 12.7969 22.0928 12.1992 21.7217 11.832L15.7884 5.94922C15.4212 5.58594 14.8314 5.58594 14.4642 5.95313L13.6088 6.80859C13.2299 7.18359 13.2455 7.80078 13.6362 8.16016V8.16016Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }